import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useTriggerSectionIsViewedGaEvent } from 'core/hooks/useTriggerSectionIsViewedGaEvent';
import { selectSiteUrl } from 'core/selectors/app';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import { useGetAccountSummary } from 'core/modules/AccountSummary/hooks/useGetAccountSummary';

import orgConfig from 'org/configs/org.config';

import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import TransactionSnapshot from './components/TransactionSnapshot/TransactionSnapshot';
import { triggerEarningsSnapshotIsViewed } from './actions';
import { selectEarningsSnapshotConfig } from './selectors';
import { useGetEarningsSnapshot } from './hooks/useGetEarningsSnapshot';

import './EarningsSnapshot.scss';

function EarningsSnapshot() {
  const dispatch = useDispatch();
  const earningsSnapshotRef = useRef();

  const siteUrl = useSelector(selectSiteUrl);
  const config = useSelector(selectEarningsSnapshotConfig);
  const { accountSummaryData } = useGetAccountSummary();
  const { transactions } = useGetEarningsSnapshot();
  const { lifetimeEarningFormatted, lifetimeEarningValue, lifetimeEarning } = accountSummaryData;
  const {
    secTitle, bonusTitle, getMarketingProgramName, ctaText, shouldShowEarnType,
    formatRebate, showLifetimeEarningFormatted,
  } = config;
  const { earnType } = orgConfig;

  const marketingProgramName = getMarketingProgramName();

  const dispatchTriggerSectionIsViewed = () => dispatch(triggerEarningsSnapshotIsViewed());
  useTriggerSectionIsViewedGaEvent(earningsSnapshotRef, dispatchTriggerSectionIsViewed);

  const userHasLifetimeEarning = !!(lifetimeEarningValue && lifetimeEarningValue > 0);
  const lifetimeEarningShown = showLifetimeEarningFormatted ? lifetimeEarningFormatted : lifetimeEarning;
  const earnTypeShown = shouldShowEarnType ? earnType : '';

  if (isEmpty(transactions) || !userHasLifetimeEarning) {
    return null;
  }

  return (
    <div className="mn_earningsSnapshot" ref={earningsSnapshotRef}>
      <ContentWrap>
        <SectionTitle title={secTitle} />
        <p className="mn_summary">
          You've earned {lifetimeEarningShown || 0} {marketingProgramName}
          {earnTypeShown} just for shopping.
          Check out those recent transactions, and keep up the great work.
        </p>
        <div className="mn_transactions">
          { transactions.map((transaction) => (
            <TransactionSnapshot
              transaction={transaction}
              bonusTitle={bonusTitle}
              key={transaction.transactionId}
              earnTypeShown={earnTypeShown}
              formatRebate={formatRebate}
            />
          ))}
        </div>
        <a href={`${siteUrl}/ai____.htm`} className="mn_button">{ctaText}</a>
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><EarningsSnapshot {...props} /></ComponentErrorBoundary>;
